<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/buildings/buildings-router.component.ts.BuildingsRouterComponent.html